import React, { FC, ReactNode } from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import css from './styles.module.scss';

interface IFormMakeupProps {
  mode: 'sign-in' | 'sign-up' | 'forgot-password' | 'change-password';
  children: ReactNode;
}

const FormMakeup: FC<IFormMakeupProps> = ({ mode = 'sign-in', children }) => {
  const { t } = useTranslation();
  const tabtitles: Record<IFormMakeupProps['mode'], string> = {
    'sign-in': t('form.common.authorization'),
    'sign-up': t('form.common.signup'),
    'forgot-password': t('form.common.forgot'),
    'change-password': t('form.common.authorization'),
  };

  return (
    <div className={css.form}>
      <Helmet>
        <title>{tabtitles[mode]}</title>
      </Helmet>
      {children}
    </div>
  );
};

export default FormMakeup;
